import { render, staticRenderFns } from "./integralRule.vue?vue&type=template&id=22a1ced2&scoped=true&"
import script from "./integralRule.vue?vue&type=script&lang=js&"
export * from "./integralRule.vue?vue&type=script&lang=js&"
import style0 from "./integralRule.vue?vue&type=style&index=0&id=22a1ced2&lang=stylus&scoped=true&"
import style1 from "./integralRule.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1ced2",
  null
  
)

export default component.exports